export default __webpack_public_path__ + "static/media/ponentes_JavierAmozurrutia.9fa6001a.jpg";